/**
 * CONTACT.THOMAS
 * Infos to contact Thomas best boy !
 */

import Contact from "@/components/contact"
import Modal from "@/components/modal"
import { Session } from "@/redux/_session.types"
import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import { InlineWidget } from "react-calendly"

interface StateProps {
  _session: Session
}

interface OwnProps extends WithTranslation {
  onClose: Function
}

type Props = StateProps & OwnProps

function ContactModal(props: Props) {
  const { t } = props

  return (
    <Modal disableOverflow onClose={() => props.onClose()} isCloseButtonVisible title={t("onboarding_end_questions")}>
      {props._session.features.risks ? (
        <div style={{ height: 600, margin: "0px -40px" }}>
          <InlineWidget url="https://calendly.com/idtree-thomas/presentation-idtree-enquete-qvct-rps-clone" />
        </div>
      ) : (
        <Contact />
      )}
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(ContactModal))
